@if (translations.loaded()) {
  <router-outlet></router-outlet>
}



